module.exports = __webpack_public_path__ + "img/744.1296a14a.jpg";